import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SupportPlatforms from './SupportPlatforms.jsx';

// Componente de scores animados
const ScoreSlider = () => {
  const scores = [
    { type: 'SAT', score: 1600, label: 'Perfect Score' },
    { type: 'SAT', score: 1550, label: 'Top 1%' },
    { type: 'ACT', score: 36, label: 'Perfect Score' },
    { type: 'ACT', score: 35, label: 'Top 1%' },
    { type: 'SAT', score: 1500, label: 'Top 5%' },
    { type: 'ACT', score: 34, label: 'Top 2%' },
    { type: 'SAT', score: 1450, label: 'Top 10%' },
    { type: 'ACT', score: 33, label: 'Top 5%' },
    { type: 'SAT', score: 1400, label: 'Top 15%' },
    { type: 'ACT', score: 32, label: 'Top 10%' },
    { type: 'SAT', score: 1350, label: 'Top 25%' },
    { type: 'ACT', score: 31, label: 'Top 15%' },
    { type: 'SAT', score: 1300, label: 'Top 35%' },
    { type: 'ACT', score: 30, label: 'Top 25%' },
    { type: 'SAT', score: 1250, label: 'Top 50%' },
    { type: 'ACT', score: 29, label: 'Top 35%' },
    { type: 'SAT', score: 1200, label: 'Above Average' },
    { type: 'ACT', score: 28, label: 'Top 50%' },
    { type: 'SAT', score: 1150, label: 'Average' },
    { type: 'ACT', score: 27, label: 'Above Average' },
    { type: 'SAT', score: 1100, label: 'Below Average' },
    { type: 'ACT', score: 26, label: 'Average' },
    { type: 'SAT', score: 1050, label: 'Low' },
    { type: 'ACT', score: 25, label: 'Below Average' },
    { type: 'SAT', score: 1000, label: 'Minimum' },
    { type: 'ACT', score: 24, label: 'Low' },
  ];

  return (
    <div className="score-slider">
      <div className="score-track">
        {[...scores, ...scores].map((item, index) => (
          <div key={index} className={`score-item ${item.type.toLowerCase()}`}>
            <span className="score-type">{item.type}</span>
            <span className="score-value">{item.score}</span>
            <span className="score-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const Home = () => {
    return (
        <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
        transition={{duration: 0.5}}
        className="home-container">   
        
        {/* Hero con slider de scores */}
        <section className="hero py-20 relative overflow-hidden">
            {/* Background Slider */}
            <ScoreSlider />
            
            <div className="container relative z-10">
                <div className="text-center mb-8">
                    <motion.h1 
                    className="section-title"
                    initial={{y: -20, opacity: 0}}
                    animate={{y: 0, opacity: 1}}
                    transition={{duration: 0.5}}>
                        ExamGuard</motion.h1>
                    <motion.p 
                        className="text-xl text-secondary mb-6"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            Designed to simplify exam preparation and optimize academic performance.
                    </motion.p>
                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        >
                            <Link to="/dashboard" className="btn btn-lg">
                                Go to Dashboard
                            </Link>
                        </motion.div>
                </div>
            </div>
            </section>

            {/* Features section */}
            <section className="features py-16">
                <div className="container">
                    <h2 className="section-title text-center mb-8">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-3">
                        <motion.div
                            className="card"
                            whileHover={{ y: -5 }}
                            transition={{ type: "spring", stiffness: 300 }}
                            >
                                <div className="feature-icon mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                    <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
                                    </svg>
                                </div>

                                <h3 className="text-x1 font-semibold mb-2"> 
                                    Full Compatibility
                                </h3>
                                <p className="text-secondary">
                                    Powering top performance on every major college entrance exam platform.
                                </p>
                                </motion.div>

                                <motion.div
                                className="card"
                                whileHover={{ y: -5 }}
                                transition={{ type: "spring", stiffness: 300 }}
                                >
                                <div className="feature-icon mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                    </svg>
                                </div>
                                <h3 className="text-x1 font-semibold mb-2">
                                    Guaranteed Security
                                </h3>
                                <p className="text-secondary">
                                    Built with enterprise-grade data privacy and secure session management.
                                </p>
                                </motion.div>

                                <motion.div
                                className="card"
                                whileHover={{ y: -5 }}
                                transition={{ type: "spring", stiffness: 300 }}
                                >
                                <div className="feature-icon mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                                        </svg>
                                </div>
                                <h3 className="text-x1 font-semibold mb-2">
                                    Optimal Performance
                                </h3>
                                <p className="text-secondary">
                                    Optimized for maximum stability without compromising system performance.
                                </p>
                                </motion.div>

                                </div>
                        </div>
                {/* Supported Platforms Section */}
                <SupportPlatforms />
            </section>
        </motion.div>
    );
};

export default Home;